import { takeLatest } from 'redux-saga/effects'
import abstractDuck from '../helpers/singleActionDuck'

// The dashboard's "Initial health forms incomplete" tile: the residents list request with
// limit 1, read for its total. Its own slice so the residents list's state is never touched.
const apiUrl = `${process.env.REACT_APP_API_URL}/residents`
const name = 'residentsInitialFormsCount'
const { types, actions, sagas, selectors, reducers } = abstractDuck({ name, apiUrl, method: 'GET' })

export const slice = {
  types,
  actions,
  sagas: [takeLatest(types.ACTION, sagas[name])],
  selectors
}

export default reducers
